import Markdown from "components/markdown/markdown";

export default function Headline({
  headline,
  subhead,
}: {
  headline: string;
  subhead: string;
}) {
  return (
    <div className="mb-[15px] md:mb-[70px] lg:mb-10">
      {headline && (
        <Markdown
          text={headline}
          className="text-black-rock mb-[30px] font-recklessBold text-[32px] leading-[130%] md:w-[550px] lg:w-[893px] lg:text-[52px]"
        />
      )}
      {subhead && (
        <Markdown
          text={subhead}
          className="mb:text-[16px] mb-[70px] text-[16px] leading-[130%] text-mono-70"
        />
      )}
    </div>
  );
}
